/*
 * @Author: cmchiu
 * @Date: 2023-04-06 14:05:57
 * @LastEditTime: 2023-06-02 14:03:11
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\utils\menu.js
 *
 */
import XEUtils from 'xe-utils'
import Layout from '@/layout'
import { isExternal } from '@/utils/validate'
import { getPagePath } from '@/api/common'

const postRegex = /(p|P)ost$/

// 加载菜单，在创建路由时使用
export const loadMenu = routes => {
    let list = []
    let data = routes
    if (!data) {
        return list
    }
    list = genMenu(data)

    return list
}

function genMenu(list) {
    // 轉成樹狀結構
    let menuTree = XEUtils.toArrayTree(list, {
        strict: true,
        key: 'MenuID',
        parentKey: 'UpperMenuID',
        children: 'children',
        sortKey: 'sort',
        // data: 'data',
    })

    // 將樹狀結構轉成菜單格式
    let formatMenuTree = []
    XEUtils.arrayEach(menuTree, item => {
        let node = formatMenu(null, item)
        formatMenuTree.push(node)
    })

    return formatMenuTree
}

// 格式化菜單
function formatMenu(pnode, node) {
    const isRoot =
        pnode === null &&
        (!node.children ||
            node.children.length === 0 ||
            !node.Visible ||
            XEUtils.filter(node.children, item => item.MenuPath && !postRegex.test(item.MenuPath)).length === 0)
    let viewPath = pnode === null ? '' : `${pnode.tmpPath}/${node.MenuPath}`

    let tmpNode = {
        name: node.MenuID,
        path: `${pnode === null && !isExternal(node.MenuPath) ? '/' : node.MenuPath}`,
        meta: {
            title: node.MenuTitle,
            // icon: node.FuncIcon,
            // keepAlive: !node.NoCache,
        },
        hidden: !node.Visible,
        component: pnode === null ? Layout : getViews(node.MenuPath),
        tmpPath: /* pnode === null ? node.MenuPath : */ viewPath,
    }

    if (isRoot) {
        tmpNode.meta['subMenu'] = false
        tmpNode['children'] = []
        tmpNode['children'].push({
            name: node.MenuID,
            path: node.MenuPath,
            meta: {
                title: node.MenuTitle,
                // icon: node.FuncIcon,
                // keepAlive: !node.NoCache,
            },
            component: getViews(node.MenuPath),
            hidden: !node.Visible,
        })
        if (!isExternal(node.MenuPath)) {
            tmpNode['redirect'] = `/${node.MenuPath}`
        }
    } else if (node.children && node.children.length > 0) {
        tmpNode.meta['subMenu'] = true
        tmpNode['children'] = []
        XEUtils.arrayEach(node.children, item => {
            let child = formatMenu(tmpNode, item)
            // tmpNode['tmpPath'] = child.tmpPath
            tmpNode['children'].push(child)
        })
        // if (pnode === null) tmpNode['redirect'] = `/${tmpNode.tmpPath}`
        if (!isExternal(tmpNode.children[0].path)) {
            tmpNode['redirect'] = `/${tmpNode.children[0].path}`
        } else {
            tmpNode['redirect'] = tmpNode.children[0].path
        }
    }
    // 如果有post頁...
    let postPage = XEUtils.find(node.children, item => item.MenuPath && postRegex.test(item.MenuPath))
    if (postPage) {
        tmpNode['children'].push({
            name: postPage.MenuID,
            path: postPage.MenuPath,
            meta: {
                title: postPage.MenuTitle,
                // icon: node.FuncIcon,
                // keepAlive: !node.NoCache,
            },
            component: getViews(postPage.MenuPath),
            hidden: !postPage.Visible,
        })
    }

    return tmpNode
}

function getViews(path) {
    const arr = path.split('/')
    const hasFolder = [] //例外狀況: 如果有實際資料夾的話,將資料夾名稱放在這
    if (hasFolder.includes(arr[0])) {
        return resolve => {
            require.ensure([], require => {
                resolve(require('@/views/' + path))
            })
        }
    } else {
        return resolve => {
            require.ensure([], require => {
                resolve(require('@/views/' + arr[arr.length - 1]))
            })
        }
    }
}

export const getPath = id => {
    return new Promise((resolve, reject) => {
        getPagePath({ id })
            .then(res => {
                resolve(res.Items)
            })
            .catch(error => {
                reject(error)
            })
    })
}
